import { type DatasourceResponseSchemaProperty } from '@atlaskit/linking-types';
import { type CloudId } from '@databases/types/confluence';

import { type DatasourceType } from '@canvas/atlassian-service/datasource';

import { type AsyncOperation, AsyncOperationStatus } from '../async-operation';

import { type DatasourcesState } from './slice';

type ContextState = {
  datasources: DatasourcesState;
};

export function selectSupportedProperties(
  state: ContextState,
  cloudId: CloudId,
  datasourceType: DatasourceType
): DatasourceResponseSchemaProperty[] {
  if (
    selectSupportedPropertiesStatus(state, cloudId, datasourceType)?.status ===
    AsyncOperationStatus.ERROR
  ) {
    return [];
  }
  const cloudIdKey = cloudId ?? '';
  return state.datasources.supportedProperties[datasourceType]?.[cloudIdKey];
}

export function selectSupportedPropertiesStatus(
  state: ContextState,
  cloudId: CloudId,
  datasourceType: DatasourceType
): AsyncOperation<void> | undefined {
  const cloudIdKey = cloudId ?? '';
  return state.datasources.supportedPropertiesStatus[datasourceType]?.[cloudIdKey];
}
